import { Component } from '@angular/core';
import { SharedModule } from "../../../shared/shared.module";

@Component({
  selector: 'app-app-store-banner-section',
  templateUrl: './app-store-banner-section.component.html',
  styleUrl: './app-store-banner-section.component.scss',
  standalone : true,
  imports: [SharedModule],
})
export class AppStoreBannerSectionComponent {
  stores: any[] = [
    {
      name: 'Play Store',
      icon: 'play_store',
    },
    {
      name: 'App Store',
      icon: 'apple_store',
    },
    {
      name: 'Huawei App Gallery',
      icon: 'huawei_app_gallery',
    },
    {
      name: 'Linux Store',
      icon: 'linux_store',
    },
    {
      name: 'Windows Store',
      icon: 'microsoft_store',
    },
  ];
}
